<!--
 * @Author: zxf
 * @Date: 2022-07-20 18:18:58
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:42:48
 * @Description: 编辑维保项目
-->
<template>
  <div
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        编辑维保项目
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="保存项目信息"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave"
        />
        <k-button
          btn-text="新增建筑"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleAddJz"
        />
        <k-button
          btn-text="新增维保计划"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleAddWbjh"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：仅tabs为主内容 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <el-tabs
        v-model="activeName"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
      >
        <el-tab-pane
          label="项目信息"
          name="wbxm"
        >
          <update-wbxm
            ref="wbxm"
            type="wbxm"
            @handleWbxmInfo="handleWbxmInfo"
          />
        </el-tab-pane>

        <el-tab-pane
          label="建筑信息"
          name="wbjz"
        >
          <wbjz-list
            ref="wbjzList"
            type="wbjzList"
            :pagination-show="false"
          />
        </el-tab-pane>
        <el-tab-pane
          label="维保计划信息"
          name="wbjh"
        >
          <wbjh-list
            ref="wbjhList"
            type="wbjhManage"
          />
        </el-tab-pane>
        <!-- <el-tab-pane
          label="会议列表"
          name="hygl"
        >
          会议列表
        </el-tab-pane>
        <el-tab-pane
          label="设备列表"
          name="wbsb"
        >
          设备列表
        </el-tab-pane> -->

      <!-- 页面主内容：仅tabs为主内容 End -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import UpdateWbxm from './updateWbxm.vue';
import WbjhList from './wbjhList.vue';
import WbjzList from '../wbjz/wbjzList.vue';

export default {
  name: 'EditWbxm',
  components: {
    UpdateWbxm,
    WbjhList,
    WbjzList
  },
  data () {
    return {
      loading: false, // 页面loading状态
      activeName: 'wbxm',
      xmid: null,
      wbxmInfo: null // 维保项目信息
    };
  },
  methods: {
    /**
     * @description: 保存项目信息
     * @return {*}
     */
    handleSave () {
      this.activeName = 'wbxm';
      this.$refs.wbxm.handleEdit();
    },
    /**
     * @description: 新增建筑
     * @return {*}
     */
    handleAddJz () {
      this.activeName = 'wbjz';
      this.$refs.wbjzList.handleDialog('add', { dlType: 'add' });
    },
    /**
     * @description: 新增维保计划
     * @return {*}
     */
    handleAddWbjh () {
      this.activeName = 'wbjh';
      this.$refs.wbjhList.handleDialog('add', { dlType: 'add', xmid: this.xmid });
    },

    /**
     * @description: 维保项目信息处理
     * @return {*}
     * @param {*} data
     */
    handleWbxmInfo (data) {
      this.wbxmInfo = data;
    }

  },
  created () {
    this.xmid = this.$route.params.xmid;
  }
};
</script>

<style lang="scss">
.dev-c-tab--body{
  width: 100%;
  height: 100%;
}

</style>
